import { FunctionComponent, useMemo } from 'react'
import { ToastProps } from './types'
import { useValidateStates } from './utils'
import { ReactComponent as SucessIcon } from '@/assets/icon_sucess.svg'
import { ReactComponent as DangerIcon } from '@/assets/icon_danger.svg'
import { ReactComponent as WarningIcon } from '@/assets/icon_warning.svg'
import { ReactComponent as CloseIcon } from '@/assets/icon_close.svg'
import useStyles from './styles'
import { Link } from '../Link'
import { css } from '@conexasaude/styles'

export const Toast: FunctionComponent<ToastProps> = ({
  styles: overrides,
  children,
  icon,
  theme: propTheme,
  variant: propVariant,
  action,
  actionLabel,
  onClose,
}) => {
  const { theme, variant } = useValidateStates({ propTheme, propVariant })
  const styles = useStyles({ theme, variant, hasAction: !!action })

  const currentIcon = useMemo(() => {
    if (variant) {
      const iconDict = {
        success: <SucessIcon />,
        warning: <WarningIcon />,
        danger: <DangerIcon />,
      }
      return iconDict[variant]
    }
    return icon
  }, [variant, icon])

  const actionStyles = useMemo(() => css([styles.action, overrides?.action]), [
    styles.action,
    overrides?.action,
  ])

  return (
    <div
      css={[styles.root, overrides?.root]}
      data-testid="hero-toast"
      className="hero-toast_root"
    >
      <div
        css={[styles.content, overrides?.content]}
        className="hero-toast_content"
      >
        {currentIcon}
        <span>{children}</span>
      </div>
      <div
        css={[styles.actions, overrides?.actions]}
        className="hero-toast_actions"
      >
        {!!action && (
          <Link
            renderAs="button"
            onClick={action}
            styles={{ root: actionStyles }}
            className="hero-toast_action"
            data-testid="actionLink"
          >
            {actionLabel}
          </Link>
        )}
        <button
          onClick={() => onClose()}
          css={[styles.close, overrides?.close]}
          className="hero-toast_close"
        >
          <CloseIcon />
        </button>
      </div>
    </div>
  )
}
